export default "/arrows.8a262729b1604fef9bf7feab21c76ec4.svg";